import { render } from "./eventos.vue?vue&type=template&id=39e788d6&scoped=true"
import script from "./eventos.vue?vue&type=script&lang=js"
export * from "./eventos.vue?vue&type=script&lang=js"

import "./eventos.vue?vue&type=style&index=0&id=39e788d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e788d6"]])

export default __exports__